import { render, staticRenderFns } from "./Charecters.vue?vue&type=template&id=3e888b72&scoped=true&"
import script from "./Charecters.vue?vue&type=script&setup=true&lang=js&"
export * from "./Charecters.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Charecters.vue?vue&type=style&index=0&id=3e888b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e888b72",
  null
  
)

export default component.exports